import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import StockDetailModal from "@/components/StockDetailModal";
import AiAnalysisModal from "@/components/AiAnalysisModal";

const ModalContext = createContext(null);
export const useModals = () => useContext(ModalContext);

export function ModalProvider({ children }) {
  const [detailSymbol, setDetailSymbol] = useState(null);
  const [analysisSymbol, setAnalysisSymbol] = useState(null);

  const openStockDetail = useCallback((s) => setDetailSymbol(s), []);
  const openAiAnalysis = useCallback((s) => setAnalysisSymbol(s), []);
  const value = useMemo(() => ({ openStockDetail, openAiAnalysis }), [openStockDetail, openAiAnalysis]);

  return (
    <ModalContext.Provider value={value}>
      {children}
      <StockDetailModal symbol={detailSymbol} onClose={() => setDetailSymbol(null)} />
      <AiAnalysisModal symbol={analysisSymbol} onClose={() => setAnalysisSymbol(null)} />
    </ModalContext.Provider>
  );
}
